














































import AppModal from '@/components/AppModal.vue'
import { createComponent, ref, computed } from '@vue/composition-api'
import { Carousel, Slide } from 'vue-carousel'

export default createComponent({
  name: 'TutorialModal',
  components: {
    AppModal,
    Carousel,
    Slide
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    dismiss: {
      type: Function
    }
  },
  setup (props) {
    const page = ref('home')

    const isHome = computed(() => page.value === 'home')
    const isAdd = computed(() => page.value === 'add')
    const isUpdate = computed(() => page.value === 'update')

    const createCarousel = ref<HTMLElement>(null)
    const updateCarousel = ref<HTMLElement>(null)

    const openHome = () => { page.value = 'home' }
    const openAdd = () => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
      (createCarousel.value! as any).goToPage(0)
      page.value = 'add'
    }
    const openUpdate = () => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
      (updateCarousel.value! as any).goToPage(0)
      page.value = 'update'
    }

    const addImages = new Array(7).fill(true).map((_, index) => `/images/tutorial/create-${index + 1}.jpg`)
    const updateImages = new Array(4).fill(true).map((_, index) => `/images/tutorial/update-${index + 1}.jpg`)

    const onDismissClick = () => {
      openHome()
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      props.dismiss!()
    }

    return {
      isHome,
      isAdd,
      isUpdate,
      openHome,
      openAdd,
      openUpdate,
      addImages,
      updateImages,
      onDismissClick,
      createCarousel,
      updateCarousel
    }
  }
})
